<app-certificate-summary [certificate]="certificate"></app-certificate-summary>

<div class="mt-3">
  <app-vehicle-list [account]="certificate"></app-vehicle-list>
</div>